import { INPUT_TYPES } from '../utils/constants';
import { createOptions } from '../utils/utils';
import { default as GALLERY_CONSTS } from '../../common/constants';
export default {
    title: 'Click Action',
    isRelevant: function () { return true; },
    isRelevantDescription: 'Always relevant.',
    type: INPUT_TYPES.OPTIONS,
    default: GALLERY_CONSTS.itemClick.NOTHING,
    options: createOptions('itemClick'),
    description: "Specifies what happens when an item is clicked. To enable the 'expand' or 'fullscreen' options, make sure you're using the ExpandableProGallery component",
};
//# sourceMappingURL=itemClick.js.map